import Routes from "./routes";
import AuthProvider from "./provider/authProvider";
import { ColorModeProvider } from "./provider/colorModeProvider";
import InstallPrompt from "./components/InstallPrompt";

function App() {
  return (
    <ColorModeProvider>
      <AuthProvider>
        <Routes/>
        <InstallPrompt />
      </AuthProvider>
    </ColorModeProvider>
  );
}


export default App;
